module.exports = __webpack_public_path__ + "static/media/18ECA30.6924d0f2.jpg";